import { __read } from "tslib";
import { useState, useEffect } from 'react';
import { hasContentOverflow } from '@keen.io/charts-utils';
import { BUTTON_DIMENSION, BUTTON_SHADOW_SIZE } from './slider-button';
export var useRenderMode = function (element, layout, position, initialMode, labelsLength) {
    var _a = __read(useState(initialMode), 2), mode = _a[0], setMode = _a[1];
    var _b = __read(useState({
        offset: 0,
        scroll: 0,
    }), 2), initialDimension = _b[0], setDimension = _b[1];
    useEffect(function () {
        setMode(initialMode);
    }, [layout, position, initialMode, labelsLength]);
    useEffect(function () {
        var contentOverflow = hasContentOverflow(layout, element.current);
        var _a = element.current, offsetHeight = _a.offsetHeight, offsetWidth = _a.offsetWidth, scrollHeight = _a.scrollHeight, scrollWidth = _a.scrollWidth;
        if (contentOverflow && layout === 'horizontal') {
            switch (mode) {
                case 'list':
                    setDimension({ offset: offsetWidth, scroll: scrollWidth });
                    setMode('group');
                    break;
                case 'group':
                    setMode('slider');
                    break;
            }
        }
        if (contentOverflow && layout === 'vertical') {
            switch (mode) {
                case 'list':
                    setDimension({ offset: offsetHeight, scroll: scrollHeight });
                    setMode('slider');
                    break;
            }
        }
    }, [mode, layout, element, labelsLength]);
    return { mode: mode, initialDimension: initialDimension };
};
export var createSliderTransition = function (variant, index, itemSize, itemGap, sliderSize) {
    var itemPosition = index * (itemSize + itemGap) + (BUTTON_DIMENSION + BUTTON_SHADOW_SIZE);
    var itemPositionPrevious = itemPosition - sliderSize - itemSize - itemGap;
    var itemPositionNext = itemPosition + sliderSize + itemSize + itemGap;
    if (variant === 'horizontal')
        return {
            initial: function (direction) { return ({
                x: direction > 0 ? itemPositionNext : itemPositionPrevious,
                y: '-50%',
                top: '50%',
            }); },
            animate: { x: itemPosition },
            exit: function (direction) { return ({
                x: direction < 0 ? itemPositionNext : itemPositionPrevious,
            }); },
        };
    return {
        initial: function (direction) { return ({
            y: direction > 0 ? itemPositionNext : itemPositionPrevious,
            x: 15,
            width: 'calc(100% - 30px)',
        }); },
        animate: { y: itemPosition },
        exit: function (direction) { return ({
            y: direction < 0 ? itemPositionNext : itemPositionPrevious,
        }); },
    };
};
